import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { SpinnerOverlayService } from '../../Components/spinner/spinner-overlay.service';
import { ProductCatalogService } from './product-catalog.service';
import { IProduct } from './product.model';
import { CustomInput } from '../../Components/input/custom-input';
import { PaginatorState } from 'primeng/paginator';
import { ITEMS_PER_PAGE } from '../../core/config/pagination.constants';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { Button } from '../../Components/button/button';
import { MatDialog } from '@angular/material/dialog';
import { ProductDetailDialog } from '../product-detail-dialog/product-detail-dialog';
import { MessageService } from '../../shared/message.service';
import { RelatedItems } from '../related-items/related-items';
import { ActivatedRoute } from '@angular/router';
import { ProductCartService } from '../product-cart-component/product-cart-service';
import { OrderService } from '../order-service';

@Component({
  selector: 'app-product',
  imports: [
    FormsModule,
    NgClass,
    CustomInput,
    Button,
    TableModule,
    RelatedItems,
    NgIf
  ],
  templateUrl: './product-catalog.component.html',
  styleUrl: './product-catalog.component.css'
})
export class ProductCatalogComponent implements OnInit {
  @ViewChild('customTable') productTable!: any;

  productList: IProduct[] = []

  categories = ['Todos', 'Fibra', 'Aglomerado', 'Bordos', 'Madera sólida', 'Moldura'];
  selectedCategory = 'Todos';
  totalItems: number = 0
  product: string = ''
  first = 0;
  rows = ITEMS_PER_PAGE;
  page = 0;
  lastEvent: any;
  showRelatedItems = false;

  constructor(
    private spinner: SpinnerOverlayService,
    private productService: ProductCatalogService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cartService: ProductCartService,
    private orderService: OrderService
  ) {
  }

  ngOnInit() {
    // Cargar límites de plataforma desde el servicio
    this.loadPlatformLimits();

    this.findProductByParams();

    this.route.queryParams.subscribe(params => {
      this.showRelatedItems = params['related'] === 'true';
    });
  }

  loadPlatformLimits() {
    this.orderService.getPlatformLimits().subscribe({
      next: (response) => {
        if (response?.limits) {
          localStorage.setItem('platformLimits', JSON.stringify(response.limits));
        }
      },
      error: (err) => {
        console.error('Error fetching platform limits:', err);
      }
    });
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.onPageChange({})
  }

  findProductByParams() {
    this.handleLoading(true)

    const params = {
      page: this.page,
      size: this.rows,
      'category': this.selectedCategory,
      criteria: this.product,
      active: true
    }

    this.productService.findByParams(params).subscribe({
      next: (response) => {
        this.productList = response.body?.product.productList ?? []
        this.totalItems = response.body?.product.totalCount ?? 0
        this.handleLoading(false)
      },
      error: () => {
        this.productList = this.productList
        this.handleLoading(false)
      }
    })
    this.handleLoading(false)

  }

  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? ITEMS_PER_PAGE;
    this.page = Math.floor((this.first ?? 0) / (this.rows ?? ITEMS_PER_PAGE));

    if (this.productTable) {
      this.productTable.reset();
    }

    this.findProductByParams();
  }

  loadProducts(event: TableLazyLoadEvent) {
    if (JSON.stringify(event) === JSON.stringify(this.lastEvent)) {
      return;
    }
    this.lastEvent = event;

    this.page = Math.floor((event.first ?? 0) / (event.rows ?? ITEMS_PER_PAGE));
    this.rows = event.rows ?? ITEMS_PER_PAGE;

    this.findProductByParams();
  }

  openProductDetailDialog(product: IProduct) {
    console.log(product.id)
    if (product.id) {
      this.dialog.open(ProductDetailDialog, {
        panelClass: 'lexend-dialog',
        data: {
          id: product.id
        },
        width: '900px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        disableClose: true
      });
    } else {
      this.messageService.showError("Error: El producto no cuenta con un identificador, por favor, contactar con soporte")
    }

  }

  cleanFilter() {
    this.product = ''
    this.findProductByParams()
  }
}
